// src/components/grammar/grammarStyles.js

export const grammarStyles = () => ({
  // Base styles
  body: {
    fontFamily: "'Inter', sans-serif",
    backgroundColor: '#f8fafc'
  },

  // Tab Navigation Styles
  tabNavigation: {
    display: 'flex',
    backgroundColor: 'white',
    borderRadius: '1rem',
    padding: '0.5rem',
    marginBottom: '2rem',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    border: '1px solid #e2e8f0',
    overflowX: 'auto'
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1rem 1.5rem',
    borderRadius: '0.5rem',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontWeight: '500',
    fontSize: '0.875rem',
    minWidth: 'max-content',
    color: '#6b7280'
  },
  activeTab: {
    backgroundColor: '#4f46e5',
    color: 'white',
    boxShadow: '0 4px 6px -1px rgb(79 70 229 / 0.3)'
  },
  lockedTab: {
    opacity: 0.5,
    cursor: 'not-allowed'
  },
  masteredTab: {
    backgroundColor: '#16a34a',
    color: 'white'
  },
  tabIcon: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.875rem',
    fontWeight: '700'
  },

  // Pillar Card Styles
  pillarCard: {
    backgroundColor: 'white',
    borderRadius: '1.5rem',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.05), 0 4px 6px -4px rgb(0 0 0 / 0.05)',
    border: '1px solid #e2e8f0',
    overflow: 'hidden'
  },
pillarHeader: {
  position: 'relative',
  background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)',
  color: 'white',
  padding: '3rem 2rem',
  textAlign: 'center',
  borderRadius: '0 0 1.5rem 1.5rem',
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  borderBottom: '4px solid #3A86FF',
},
pillarTitle: {
  fontSize: '2.25rem',
  fontWeight: '800',
  marginBottom: '0.75rem',
  lineHeight: '1.2',
  letterSpacing: '-0.02em',
  textTransform: 'uppercase',
  color: '#FFFFFF',
  textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  position: 'relative',
  display: 'inline-block',
  paddingBottom: '1rem',
},
pillarSubtitle: {
  fontSize: '1.125rem',
  opacity: 0.9,
  lineHeight: '1.6',
  fontWeight: '400',
  maxWidth: '600px',
  margin: '0 auto',
  color: '#E5E7EB',
  letterSpacing: '0.01em'
},

  // Section Styles
  section: {
    padding: '2rem',
    borderBottom: '1px dashed #e2e8f0'
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '1.5rem'
  },
  subSectionTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '1rem',
    marginTop: '2rem'
  },
  contextBox: {
  backgroundColor: '#F3F4F6',
  borderLeft: '4px solid #000000',
  padding: '1.5rem',
  borderRadius: '0.75rem',
  fontStyle: 'italic',
  color: '#374151',
  marginTop: '1rem'
},

  // Explanation Styles
  explanationGrid: {
    display: 'grid',
    gap: '1.5rem',
    marginTop: '1.5rem'
  },
  explanationCard: {
    backgroundColor: '#fafbfc',
    border: '1px solid #e2e8f0',
    borderRadius: '0.75rem',
    padding: '1.5rem',
    transition: 'all 0.2s ease'
  },
  ruleCard: {
  backgroundColor: '#F0F4FF',
  borderLeft: '4px solid #3A86FF',
  padding: '1rem 1.5rem',
  borderRadius: '0.5rem',
  marginBottom: '1rem'
},
  exampleCard: {
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginBottom: '0.75rem',
    fontSize: '0.95rem'
  },
  exampleGerman: {
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '0.25rem'
  },
  exampleTranslation: {
    color: '#64748b',
    fontStyle: 'italic',
    fontSize: '0.9rem'
  },
  highlightBox: {
    backgroundColor: '#fef3c7',
    border: '1px solid #f59e0b',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginTop: '1rem'
  },
codeHighlight: {
  backgroundColor: '#F0F4FF',
  color: '#3A86FF',
  padding: '0.125rem 0.375rem',
  borderRadius: '0.25rem',
  fontFamily: 'monospace',
  fontWeight: '600',
  fontSize: '0.9rem'
},

  // Tag Styles
  tagList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginTop: '0.5rem'
  },
  tag: {
    backgroundColor: '#f1f5f9',
    color: '#475569',
    padding: '0.25rem 0.5rem',
    borderRadius: '0.375rem',
    fontSize: '0.75rem',
    fontWeight: '500'
  },

  // Exercise Styles
  exercise: {
    marginBottom: '2rem',
    padding: '1.5rem',
    border: '1px solid #e2e8f0',
    borderRadius: '1rem',
    backgroundColor: '#fafafa'
  },
  exerciseLevel: {
  display: 'inline-block',
  backgroundColor: '#F0F4FF',
  color: '#3A86FF',
  padding: '0.25rem 0.75rem',
  borderRadius: '9999px',
  fontWeight: '600',
  fontSize: '0.875rem',
  marginBottom: '1rem',
  border: '1px solid #D1E0FF'
},
  exerciseHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1rem'
  },
  exerciseMetadata: {
    display: 'flex',
    gap: '1rem',
    fontSize: '0.75rem',
    color: '#64748b'
  },

  // Input and Button Styles
  inputGroup: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    marginTop: '0.5rem'
  },
  textInput: {
    width: '100%',
    padding: '0.5rem 0.75rem',
    border: '1px solid #cbd5e1',
    borderRadius: '0.375rem',
    transition: 'all 0.2s',
    fontSize: '1rem'
  },
 checkBtn: {
  padding: '0.5rem 1rem',
  backgroundColor: '#000000',
  color: 'white',
  border: '2px solid #000000',
  borderRadius: '0.375rem',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.2s'
},
  checkBtnDisabled: {
    backgroundColor: '#94a3b8',
    cursor: 'not-allowed'
  },

  // Feedback Styles
  feedback: {
    marginTop: '0.5rem',
    padding: '0.75rem 1rem',
    borderRadius: '0.375rem',
    fontWeight: '500'
  },
  feedbackCorrect: {
    backgroundColor: '#dcfce7',
    color: '#166534'
  },
  feedbackIncorrect: {
    backgroundColor: '#fee2e2',
    color: '#991b1b'
  },

  // Progress Indicator Styles
  progressIndicator: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    padding: '1rem 2rem',
    borderTop: '1px solid #e2e8f0'
  },
  progressBar: {
    backgroundColor: '#e2e8f0',
    borderRadius: '9999px',
    height: '0.5rem',
    overflow: 'hidden',
    flexGrow: 1,
    marginLeft: '1rem'
  },
  progressFill: {
  height: '100%',
  background: 'linear-gradient(90deg, #000000 0%, #4a4a4a 100%)',
  borderRadius: '9999px',
  transition: 'width 0.3s ease'
},

  fadeIn: {
    animation: 'fadeIn 0.6s ease-out'
  },
  slideInFromRight: {
    animation: 'slideInFromRight 0.8s ease-out'
  },
  fadeInUp: {
    animation: 'fadeInUp 0.8s ease-out forwards',
    opacity: 0
  },
  storyStartButton: {
  background: '#000000',
  color: 'white',
  border: '2px solid #000000',
  padding: '0.75rem 2rem',
  borderRadius: '1rem',
  fontSize: '1.1rem',
  fontWeight: '600',
  cursor: 'pointer',
  transform: 'scale(1)',
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
},
storyStartContainer: {
  textAlign: 'center',
  padding: '3rem 2rem',
  background: '#FFFFFF',
  borderRadius: '1rem',
  marginBottom: '2rem',
  animation: 'fadeIn 0.6s ease-out',
  border: '2px solid #E5E7EB'
}
});